{
	"basePaths": {
		"view": {
			"production": "https://assets.change.org",
			"staging": "https://assets.staging-change.org",
			"demo": "https://assets.demo.changeeng.org"
		},
		"edit": {
			"production": "https://change-production.s3.amazonaws.com",
			"staging": "https://change-staging.s3.amazonaws.com",
			"demo": "https://change-demo.s3.amazonaws.com"
		}
	}
}
